export const prepareFilterValues = (filterValues = {}) => {
  const preparedFilterValues = {}

  for (let property in filterValues) {
    preparedFilterValues[property] = typeof filterValues[property] === 'object' ? JSON.stringify(filterValues[property]) : filterValues[property]
  }

  return preparedFilterValues
}
